import { useState } from "react";
import {
  Box, Button, TextField, Typography,
  DialogContent, DialogContentText, DialogActions,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useSnack } from "../hooks/useSnack";
import Btn from "../components/Btn";
import Header from "../components/Header";

export default function Inscription() {
  const theme = useTheme();
  const { showSnack, Snack } = useSnack();
  const [pseudo, setPseudo] = useState("");
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");

  const handleInscription = () => {
    if (!pseudo || !email || !pwd) {
      showSnack("Merci de remplir pseudo, email et mot de passe.", "warning");
      return;
    }
    fetch("/api/register", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ users_pseudo: pseudo, users_email: email, users_password: pwd }),
    })
      .then(async (res) => {
        const payload = await res.json().catch(() => null);
        if (!res.ok) {
          showSnack(payload?.message || "Erreur lors de l'inscription.", "error");
          return;
        }
        showSnack("Inscription réussie ! Tu peux maintenant te connecter.", "success");
        setPseudo(""); setEmail(""); setPwd("");
      })
      .catch(() => showSnack("Impossible de contacter le serveur.", "error"));
  };

  return (
    <>
      <Header />
      <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
        <Box sx={{
          backgroundColor: theme.custom.mymodal.main,
          color: theme.custom.mymodal.text,
          border: theme.custom.mymodal.border,
          borderRadius: "5px",
          width: "100%",
          maxWidth: 400,
        }}>
          <Box sx={{ display: "flex", borderRadius: "5px 5px 0 0", overflow: "hidden" }}>
            <Btn path="/connexion" sx={{ flex: 1 }} msg={
              <Typography sx={{ width: "100%", textAlign: "center", p: "8px",
                color: theme.custom.mymodal.text, fontWeight: "bold" }}>
                Connexion
              </Typography>
            } />
            <Btn path="/inscription" sx={{ flex: 1 }} msg={
              <Typography sx={{ width: "100%", textAlign: "center", p: "8px",
                color: theme.custom.mymodal.text, backgroundColor: theme.custom.mymodal.button, fontWeight: "bold" }}>
                Inscription
              </Typography>
            } />
          </Box>

          <DialogContent>
            <DialogContentText sx={{ color: theme.custom.mymodal.text }}>Pseudo</DialogContentText>
            <TextField fullWidth value={pseudo} onChange={(e) => setPseudo(e.target.value)} sx={{ mb: 2 }} />
            <DialogContentText sx={{ color: theme.custom.mymodal.text }}>Email</DialogContentText>
            <TextField type="email" fullWidth value={email} onChange={(e) => setEmail(e.target.value)} sx={{ mb: 2 }} />
            <DialogContentText sx={{ color: theme.custom.mymodal.text }}>Mot de passe</DialogContentText>
            <TextField type="password" fullWidth value={pwd} onChange={(e) => setPwd(e.target.value)} sx={{ mb: 2 }} />
          </DialogContent>

          <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
            <Button onClick={handleInscription}
              sx={{ color: theme.custom.mymodal.text, backgroundColor: theme.custom.mymodal.button }}>
              S'inscrire
            </Button>
          </DialogActions>
        </Box>
      </Box>
      {Snack}
    </>
  );
}
